// React import removed - not needed for JSX with modern React setup

/**
 * Alert Component - Reusable alert/banner component
 * 
 * @param {Object} props
 * @param {string} props.type - Alert type: 'success', 'warning', 'danger', 'info'
 * @param {string} props.title - Alert title (optional)
 * @param {string} props.message - Alert message
 * @param {React.ReactNode} props.children - Alert content (alternative to message)
 * @param {boolean} props.dismissible - Whether alert can be dismissed
 * @param {function} props.onDismiss - Dismiss callback
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.showIcon - Whether to show icon (default: true)
 */
function Alert({ 
  type = 'info', 
  title, 
  message, 
  children, 
  dismissible = false,
  onDismiss,
  className = '',
  showIcon = true,
}) {
  // Icon mapping for different alert types
  const iconMap = {
    success: 'bi-check-circle-fill',
    warning: 'bi-exclamation-triangle-fill',
    danger: 'bi-exclamation-triangle-fill',
    info: 'bi-info-circle-fill',
  }

  return (
    <div 
      className={`alert alert-${type} d-flex align-items-center mb-4 ${className}`} 
      role="alert"
    >
      {showIcon && (
        <i className={`bi ${iconMap[type]} me-2`}></i>
      )}
      <div className="flex-grow-1">
        {title && <strong>{title}:</strong>}
        {message && <span className={title ? 'ms-1' : ''}>{message}</span>}
        {children}
      </div>
      {dismissible && onDismiss && (
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onDismiss}
        ></button>
      )}
    </div>
  )
}

export default Alert
